import { i18n } from "@verbleif/lib/src/translations/i18n";
import { toast } from "vue-sonner";

export function notifyEffectiveViewsError(_error: unknown, titleKey: string, fallbackTitle: string): void {
  const title = i18n.global.te(titleKey) ? String(i18n.global.t(titleKey)) : fallbackTitle;
  toast.error(title);
}
